import script from "./ClientAppendices.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientAppendices.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__